import { Controller } from '@hotwired/stimulus';

/**
 * Controller for the delete statement with invoice choices modal
 * Handles showing/hiding rejection reason fields and form validation
 */
export default class extends Controller {
  static targets = ['form', 'invoiceItem', 'rejectReasonContainer', 'rejectReasonInput'];

  connect() {
    // Initialize all rejection reason containers as hidden
    this.rejectReasonContainerTargets.forEach((container) => {
      container.classList.add('hidden');
    });
  }

  /**
   * Toggle the rejection reason textarea visibility based on radio selection
   * @param {Event} event - The change event from radio button
   */
  toggleRejectReason(event) {
    const radio = event.target;
    const invoiceId = radio.dataset.invoiceId;
    const isReject = radio.value === 'reject';

    // Find the rejection reason container for this invoice
    const container = this.rejectReasonContainerTargets.find(
      (c) => c.dataset.invoiceId === invoiceId
    );

    if (container) {
      if (isReject) {
        container.classList.remove('hidden');
        // Focus the textarea after a brief delay for animation
        setTimeout(() => {
          const textarea = container.querySelector('textarea');
          if (textarea) {
            textarea.focus();
          }
        }, 150);
      } else {
        container.classList.add('hidden');
        // Clear the textarea when switching to detach
        const textarea = container.querySelector('textarea');
        if (textarea) {
          textarea.value = '';
        }
      }
    }
  }

  /**
   * Validate the form before submission
   * Ensures all rejected invoices have a rejection reason
   * @param {Event} event - The submit event
   */
  validateAndSubmit(event) {
    let isValid = true;
    const errors = [];

    // Check each invoice item
    this.invoiceItemTargets.forEach((item) => {
      const invoiceId = item.dataset.invoiceId;

      // Find the selected radio for this invoice
      const selectedRadio = item.querySelector(
        `input[name="invoice_choices[${invoiceId}][action]"]:checked`
      );

      if (selectedRadio && selectedRadio.value === 'reject') {
        // Find the rejection reason textarea
        const textarea = this.rejectReasonInputTargets.find(
          (t) => t.dataset.invoiceId === invoiceId
        );

        if (textarea && !textarea.value.trim()) {
          isValid = false;
          // Add visual error indication
          textarea.classList.add('border-danger-500', 'ring-2', 'ring-danger-500');
          errors.push(`Veuillez indiquer la raison du rejet pour la facture`);

          // Remove error styling after user starts typing
          textarea.addEventListener(
            'input',
            () => {
              textarea.classList.remove('border-danger-500', 'ring-2', 'ring-danger-500');
            },
            { once: true }
          );
        }
      }
    });

    if (!isValid) {
      event.preventDefault();
      // Focus the first empty rejection reason
      const firstErrorTextarea = this.rejectReasonInputTargets.find((t) => {
        const invoiceId = t.dataset.invoiceId;
        const item = this.invoiceItemTargets.find((i) => i.dataset.invoiceId === invoiceId);
        if (item) {
          const selectedRadio = item.querySelector(
            `input[name="invoice_choices[${invoiceId}][action]"]:checked`
          );
          return selectedRadio && selectedRadio.value === 'reject' && !t.value.trim();
        }
        return false;
      });

      if (firstErrorTextarea) {
        firstErrorTextarea.focus();
      }
    }
  }
}
